import pageReducer from './pageReducer';

export * from './pageActions';
export default pageReducer;
